package one.primehealth.analytics

import one.primehealth.analytics.events.AppEvent
import one.primehealth.analytics.impl.AmplitudeAppAnalytics
import one.primehealth.analytics.impl.HltmAnalytics

interface AppAnalytics {
    fun logEvent(event: AppEvent)
}

internal class AppAnalyticsImpl(
    private val amplitude: AmplitudeAppAnalytics,
    private val hltmAnalytics: HltmAnalytics,
) : AppAnalytics {

    override fun logEvent(event: AppEvent) {
        amplitude.logEvent(event)
        hltmAnalytics.logEvent(event)
    }
}